var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    {
      attrs: {
        widget: { title: _vm.$t("HEADER_BULK_TAGS"), iconClass: "fa fa-tag" }
      },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              _c("div", { staticClass: "header-extra" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.name.value,
                      expression: "filters.name.value"
                    }
                  ],
                  staticClass:
                    "form-control input-md widget-header-input m-r-10",
                  attrs: {
                    type: "search",
                    placeholder: _vm.$t("SEARCH_BULK_TAGS")
                  },
                  domProps: { value: _vm.filters.name.value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.filters.name, "value", $event.target.value)
                    }
                  }
                })
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bs-callout bs-callout-primary" },
        [
          _c("i18n", {
            attrs: { path: "BULK_TAGS_WARNING", tag: "p" },
            scopedSlots: _vm._u([
              {
                key: "url",
                fn: function() {
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "bulk-tags-link",
                        attrs: {
                          href:
                            "https://support.ringba.com/hc/en-us/articles/24340533158551-Bulk-Tags",
                          target: "_blank"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("HEADER_BULK_TAGS")))]
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "grid_table_holder" },
            [
              _c(
                "v-table",
                {
                  staticClass: "table_beauty",
                  attrs: {
                    data: _vm.bulkTags,
                    "current-page": _vm.currentPage,
                    filters: _vm.filters,
                    "page-size": 20,
                    "hide-sort-icons": true
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    },
                    totalPagesChanged: function($event) {
                      _vm.totalPages = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "body",
                        fn: function({ displayData }) {
                          return _c(
                            "tbody",
                            {},
                            [
                              !_vm.bulkTags.length
                                ? _c("tr", [
                                    _c("td", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "BULK_TAGS_EMPTY",
                                          expression: "'BULK_TAGS_EMPTY'"
                                        }
                                      ],
                                      attrs: { colspan: "100" }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(displayData, function(row, index) {
                                return [
                                  !(
                                    _vm.isMobile &&
                                    _vm.activeActionRowId == row.id
                                  )
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id,
                                          class: {
                                            "bg-row-odd": index % 2 === 0,
                                            "bg-row-even": index % 2 !== 0
                                          }
                                        },
                                        [
                                          _vm.isMobile
                                            ? _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-list-function btn-expand-actions",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.displayMobileAction(
                                                          row.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-ellipsis-v"
                                                    })
                                                  ]
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(row.name) +
                                                "\n            "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(row.tagCount) +
                                                "\n            "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          !_vm.isMobile
                                            ? _c(
                                                "td",
                                                [
                                                  _c("BulkTagsActions", {
                                                    attrs: {
                                                      "current-bulk-tag": row,
                                                      disabled: _vm.disabled
                                                    },
                                                    on: {
                                                      deleteBulkTags:
                                                        _vm.confirmDeleteBulkTags,
                                                      downloadBulkTags:
                                                        _vm.downloadBulkTags,
                                                      showBulkTagsReferences:
                                                        _vm.displayReferences
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isMobile &&
                                  _vm.activeActionRowId == row.id
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id + "-mobile",
                                          staticClass:
                                            "mobile-actions slide-right"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "10" } },
                                            [
                                              _c("BulkTagsActions", {
                                                attrs: {
                                                  "current-bulk-tag": row,
                                                  disabled: _vm.disabled
                                                },
                                                on: {
                                                  deleteBulkTags:
                                                    _vm.confirmDeleteBulkTags,
                                                  collapseActions: function(
                                                    $event
                                                  ) {
                                                    !_vm.disabled &&
                                                      _vm.hideMobileAction()
                                                  },
                                                  downloadBulkTags:
                                                    _vm.downloadBulkTags,
                                                  showBulkTagsReferences:
                                                    _vm.displayReferences
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showReferences(row.id)
                                    ? _c(
                                        "tr",
                                        {
                                          key: row.id + "-references",
                                          staticClass:
                                            "row-inline-new-form slide-down bg-row-even"
                                        },
                                        [
                                          _c(
                                            "td",
                                            { attrs: { colspan: "100" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "p-l-15 p-r-15"
                                                },
                                                [
                                                  _c(
                                                    "legend",
                                                    {
                                                      staticClass:
                                                        "f-s-13 p-b-10 p-l-0"
                                                    },
                                                    [
                                                      _c("span", {
                                                        directives: [
                                                          {
                                                            name: "t",
                                                            rawName: "v-t",
                                                            value: "REFERENCES",
                                                            expression:
                                                              "'REFERENCES'"
                                                          }
                                                        ]
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-xs btn-danger legend-right-button",
                                                          attrs: {
                                                            type: "button"
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.hideReferences
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-close",
                                                            attrs: {
                                                              "aria-hidden":
                                                                "true"
                                                            }
                                                          }),
                                                          _vm._v(
                                                            "\n                    Close\n                  "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("BulkTagsReferences", {
                                                    attrs: {
                                                      "bulk-tag-upload-id":
                                                        row.id
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    3153782102
                  )
                },
                [
                  _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                    _c(
                      "tr",
                      [
                        _vm.isMobile ? _c("th") : _vm._e(),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "TABLE_COL_NAME",
                              expression: "'TABLE_COL_NAME'"
                            }
                          ],
                          attrs: { "default-sort": "asc", "sort-key": "name" }
                        }),
                        _vm._v(" "),
                        _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "TABLE_COL_TAGCOUNT",
                              expression: "'TABLE_COL_TAGCOUNT'"
                            }
                          ],
                          attrs: {
                            "default-sort": "asc",
                            "sort-key": "tagCount"
                          }
                        }),
                        _vm._v(" "),
                        !_vm.isMobile
                          ? _c("th", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "TABLE_COL_ACTIONS",
                                  expression: "'TABLE_COL_ACTIONS'"
                                }
                              ]
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.bulkTags && _vm.bulkTags.length
                ? _c("div", { staticClass: "pagination-min" }, [
                    _c(
                      "div",
                      { staticClass: "text-center p-7" },
                      [
                        _c("smart-pagination", {
                          attrs: {
                            "current-page": _vm.currentPage,
                            "total-pages": _vm.totalPages,
                            "max-page-links": 7
                          },
                          on: {
                            "update:currentPage": function($event) {
                              _vm.currentPage = $event
                            },
                            "update:current-page": function($event) {
                              _vm.currentPage = $event
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "text-center empty-records" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "BULK_TAGS_TABLE_LOADING",
                    expression: "'BULK_TAGS_TABLE_LOADING'"
                  }
                ]
              })
            ],
            1
          ),
      _vm._v(" "),
      _vm.showConfirmation
        ? _c("BulkTagsDeleteModal", {
            attrs: {
              "bulk-tags": _vm.bulkTagsToDelete,
              "disable-modal-confirm": _vm.disableModalConfirm,
              "deleting-bulk-tags": _vm.deletingBulkTags,
              references: _vm.references,
              "has-references": _vm.hasReferences
            },
            on: {
              closeModal: _vm.closeModal,
              attestDelete: _vm.attestDelete,
              deleteBulkTags: _vm.callDeleteBulkTags
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }